import React, { useEffect, useRef, useState } from 'react';
import s from '../../s.module.less';

// hasValue：该 section 是否已有内容（接口回填或用户填过）。有内容时默认展开，
// 避免已预填的 DEA / CDS 等信息被折叠起来看不到。数据是异步回填的，
// 所以 hasValue 由 false 变 true 时也要自动展开（只自动展开一次，之后尊重用户的手动折叠）。
export default function OptionalSection({
    title,
    hasValue,
    children,
}: {
    title: string;
    hasValue?: boolean;
    children: React.ReactNode;
}) {
    const [open, setOpen] = useState(!!hasValue);
    const autoOpened = useRef(!!hasValue);

    useEffect(() => {
        if (hasValue && !autoOpened.current) {
            autoOpened.current = true;
            setOpen(true);
        }
    }, [hasValue]);

    return (
        <div className={s.wizSection}>
            <div className={s.wizSectionHeader}>
                <span className={s.optTitle}>
                    {title}
                    <span className={s.optTag}>Optional</span>
                </span>
                <button type="button" className={s.optToggle} onClick={() => setOpen((v) => !v)}>
                    {open ? 'Hide' : 'Add'}
                </button>
            </div>
            {open && children}
        </div>
    );
}
